import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHandling } from '../useAuthhandling';

function Testimonialedit() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  let { id } = useParams();
  const [formerror, setError] = useState({});

  const [service, setService] = useState([]);
  const [oldimage, setOldimage] = useState([]);
  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/review/get-testimonial/${id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {
      const data = await res.json();

      setService(data.data);
      setOldimage(data.data.customerImage);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setService({ ...service, [name]: value });
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setService({ ...service, [name]: e.target.files[0] });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.customer) {
      errors.customer = "Customer name is required!";
    }

    if (!values.rating) {
      errors.rating = "Tag is required!";
    }
    if (!values.reviews) {
      errors.reviews = "Feedback is required!";
    }
    if (!values.customerImage) {
      errors.customerImage = "Image is required!";
    } else if (values.customerImage.type) {
      if (
        values.customerImage.type === "image/jpeg" ||
        values.customerImage.type === "image/jpg" ||
        values.customerImage.type === "image/png"
      ) {
        if (values.customerImage.size > 1024 * 1000) {
          errors.customerImage =
            "maximum file size 1 mb...please upload an image less than 1 mb";
        }
      } else {
        errors.customerImage = "Only support jpg, jpeg, png image!";
      }
    }
    return errors;
  };

  const PostData = async (e) => {
    e.preventDefault();
    const ress = validate(service);
    setError(ress);
    if (
      !ress.customer &&
      !ress.rating &&
      !ress.reviews &&
      !ress.customerImage
    ) {
      const formData = new FormData();
      formData.append("customer", service.customer);
      formData.append("rating", service.rating);
      formData.append("authorType", "admin");
      formData.append("reviews", service.reviews);

      formData.append("customerImage", service.customerImage);
      formData.append("oldImage", oldimage);

      axios
        .put(
          `${Config.apiurl}/api/v1/crm/review/update-testimonial/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200 ) {
            toast.success("Sucessfully updated Testimonial", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setTimeout(() => navigate("/dashboard"), 3000);
          }
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            toast.error("Something went wrong", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
           
          }
        });
    }
  };

  useEffect(() => {
    getinfo();
  }, []);

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row grid-margin">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Testimonial Table</h4>
                    <form className="forms-sample" onSubmit={PostData}>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Customer Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="customer name"
                          name="customer"
                          value={service.customer}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.customer}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Rating</label>
                        <select
                              className="form-control "
                              style={{
                                color: "black",
                                backgroundColor: "#2b2e4c;",
                              }}
                              id="exampleInputUsername1"
                              name="rating"
                              onChange={handleInputs}
                              value={service.rating}
                            >
                            <option value={1} name="rating"   {...(service.rating === "1" ? "selected" : "")}>1 Star</option>
                            <option value={2} name="rating" {...(service.rating === "2" ? "selected" : "")}>2 Star</option>
                            <option value={3} name="rating" {...(service.rating === "3" ? "selected" : "")}>3 Star</option>
                            <option value={4} name="rating" {...(service.rating === "4" ? "selected" : "")}>4 Star</option>
                            <option value={5} name="rating" {...(service.rating === "5" ? "selected" : "")}>5 Star</option>

                        </select>
                        <label style={{ color: "red" }}>
                          {formerror.rating}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Feedback</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Feedback"
                          name="reviews"
                          value={service.reviews}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.feedback}
                        </label>
                      </div>
                      {/* <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Status</label>

                          <select
                            className="form-control "
                            style={{
                              color: "black",
                              backgroundColor: "#2b2e4c;",
                            }}
                            id="exampleInputUsername1"
                            name="status"
                            onChange={handleInputs}
                            value={service.status}
                          >
                            <option
                              {...(service.status === true ? "selected" : "")}
                              value={true}
                            >
                              true
                            </option>
                            <option
                              {...(service.status ===false ? "selected" : "")}
                              value={false}
                            >
                              false
                            </option>
                          </select>
                        </div>
                      </div> */}

                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Image (417px * 263px)
                        </label>
                        <br></br>
                        <input
                          type="file"
                          name="customerImage"
                          onChange={onFileChange}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.customerImage}
                        </label>
                        <img src={service.customerImage} width="200" alt="" />
                      </div>
                      <button
                        type="submit"
                        onClick={PostData}
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                      <ToastContainer />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Testimonialedit;
